import type { Drama } from '@/mocks/dramas';
import DramaCard from '@/pages/home/components/DramaCard';

interface DramaGridProps {
  dramas: Drama[];
}

export default function DramaGrid({ dramas }: DramaGridProps) {
  if (dramas.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-20 text-foreground-400">
        <i className="ri-movie-2-line text-5xl mb-3"></i>
        <p className="text-sm">暂无相关电视剧，请尝试其他分类</p>
      </div>
    );
  }

  return (
    <div
      className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4 md:gap-5"
      data-product-shop
    >
      {dramas.map((drama) => (
        <DramaCard key={drama.id} drama={drama} />
      ))}
    </div>
  );
}